import * as moment from "moment";

export function weekDayIndex() {
  return (new Date()).getDay();
}

export function currentDayName() {
  return moment().format('dddd').toLowerCase()
}
